import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  getCalendarDisplayHours,
  updateCalendarDisplayHours,
} from 'src/redux/calendar-settings/api';
import {
  type CalendarDisplayHoursResponse,
  type CalendarSettingsState,
  calendarSettingsInitialState,
} from 'src/redux/calendar-settings/types';

const applyDisplayHours = (
  state: CalendarSettingsState,
  action: PayloadAction<CalendarDisplayHoursResponse>,
) => {
  state.startHour = action.payload?.calendar_display_start_hour ?? null;
  state.endHour = action.payload?.calendar_display_end_hour ?? null;
  state.isFetched = true;
};

const calendarSettingsSlice = createSlice({
  name: 'calendarSettings',
  initialState: calendarSettingsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCalendarDisplayHours().fulfilled, applyDisplayHours);
    builder.addCase(updateCalendarDisplayHours().fulfilled, applyDisplayHours);
  },
});

export default calendarSettingsSlice.reducer;
